import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import ReplyIcon from "@material-ui/icons/Reply";
import ForwardIcon from "@material-ui/icons/Forward";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";
import AddIcon from "@material-ui/icons/Add";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
// import { v4 as uuidv4 } from "uuid";

import toastError from "../../errors/toastError";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForwardModal from "../../components/ForwardMessageModal";
import ShowTicketOpen from "../ShowTicketOpenModal";
import AcceptTicketWithoutQueue from "../AcceptTicketWithoutQueueModal";
import { existingTicketFromError, canOpenExistingTicket } from "../../utils/existingTicket";
import { QUICK_REACTIONS, sameEmoji } from "../MessagesList/reactions";

// Menu da mensagem no padrão do WhatsApp Web: lista limpa, ícone à esquerda, apagar em vermelho por último.
const useStyles = makeStyles((theme) => ({
  paper: {
    minWidth: "200px !important",
    borderRadius: 12,
  },
  list: {
    padding: "6px 0",
  },
  item: {
    gap: 14,
    minHeight: 40,
    padding: "8px 18px 8px 16px",
    borderRadius: 0,
    fontSize: 14.5,
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": {
      fontSize: 20,
      color: theme.palette.text.secondary,
      flex: "none",
    },
  },
  danger: {
    color: theme.palette.error.main,
    "& .MuiSvgIcon-root": { color: theme.palette.error.main },
  },
  // reações rápidas no topo do menu (é por onde se reage no celular, que não tem "passar o mouse")
  reactions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    padding: "2px 10px 8px",
    marginBottom: 4,
    borderBottom: `1px solid ${theme.palette.divider}`,
    outline: "none",
  },
  reaction: {
    width: 34,
    height: 34,
    padding: 0,
    border: 0,
    borderRadius: "50%",
    background: "transparent",
    cursor: "pointer",
    fontSize: 22,
    lineHeight: "34px",
    fontFamily: '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif',
    "&:hover, &:focus-visible": { backgroundColor: theme.palette.action.hover, outline: "none" },
  },
  reactionMine: {
    backgroundColor: theme.palette.action.selected,
  },
  reactionMore: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.secondary,
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
}));

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  isGroup,
  queueId,
  whatsappId,
  channel,
  ticketStatus,
  canReact = false,
  myReaction = null,
  onReact,
  onReactMore
}) => {
  const classes = useStyles();
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const editingContext = useContext(EditMessageContext);
  const setEditingMessage = editingContext ? editingContext.setEditingMessage : null;
  const { setTabOpen } = useContext(TicketsContext);
  const history = useHistory();

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);

  const [ticketOpen, setTicketOpen] = useState(null);

  const { showSelectMessageCheckbox,
    setShowSelectMessageCheckbox,
    selectedMessages,
    forwardMessageModalOpen,
    setForwardMessageModalOpen } = useContext(ForwardMessageContext);

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;

    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        userId: user?.id,
        status: "open",
        queueId: queueId,
        whatsappId: whatsappId
      });

      setTicketOpen(ticket);
      if (ticket.queueId === null) {
        setAcceptTicketWithouSelectQueueOpen(true);
      } else {
        setTabOpen("open");
        history.push(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      const ticket = existingTicketFromError(err);

      if (!ticket) {
        toastError(err);
      } else if (!canOpenExistingTicket(ticket, user?.id)) {
        setOpenAlert(true);
        setUserTicketOpen(ticket?.user?.name);
        setQueueTicketOpen(ticket?.queue?.name);
      } else {
        setOpenAlert(false);
        setUserTicketOpen("");
        setQueueTicketOpen("");

        // handleSelectTicket(ticket);
        setTabOpen(ticket.status);
        history.push(`/tickets/${ticket.uuid}`);
      }
    }
    //setLoading(false);
    handleClose();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const handleSetShowSelectCheckbox = () => {
    setShowSelectMessageCheckbox(!showSelectMessageCheckbox);
    handleClose();
  };

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleEditMessage = async () => {
    setEditingMessage(message);
    handleClose();
  }
  // const handleForwardMessage = (msg) => {
  //   setForwardModalOpen(true);
  //   setForwardMessage(msg);
  //   handleClose();
  // };
  // const handleCloseForwardModal = () => {

  //   //setSelectedSchedule(null);
  //   setForwardModalOpen(false);
  //   handleClose();
  // };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  // Texto próprio: nota interna edita sempre (fica só no sistema); no WhatsApp (conexão por QR)
  // até 15 minutos, como no aplicativo. Canal oficial, Facebook e Instagram não editam.
  const EDITABLE_TYPES = ["chat", "conversation", "extendedTextMessage"];
  const canEditMessage = () => {
    if (!message?.fromMe || message.isDeleted || !setEditingMessage) return false;
    if (ticketStatus === "closed") return false;
    if (!EDITABLE_TYPES.includes(message.mediaType) || !message.body) return false;
    if (message.isPrivate) return true;
    if (channel && channel !== "whatsapp") return false;
    return isWithinFifteenMinutes();
  };

  const isWithinFifteenMinutes = () => {
    const fifteenMinutesInMilliseconds = 15 * 60 * 1000; // 15 minutos em milissegundos
    const currentTime = new Date();
    const messageTime = new Date(message.createdAt);

    // Verifica se a diferença entre o tempo atual e o tempo da mensagem é menor que 15 minutos
    return currentTime - messageTime <= fifteenMinutesInMilliseconds;
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  return (
    <>
      <AcceptTicketWithoutQueue
        modalOpen={acceptTicketWithouSelectQueueOpen}
        onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
        ticket={ticketOpen}
        ticketId={ticketOpen?.id}
      />
      <ShowTicketOpen
        isOpen={openAlert}
        handleClose={handleCloseAlert}
        user={userTicketOpen}
        queue={queueTicketOpen}
      />
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>

      <ForwardModal
        modalOpen={forwardMessageModalOpen}
        messages={selectedMessages}
        onClose={(e) => {
          setForwardMessageModalOpen(false);
          setShowSelectMessageCheckbox(false);
        }}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
        classes={{ paper: classes.paper, list: classes.list }}
      >
        {canReact && onReact && (
          <li className={classes.reactions} role="group" aria-label={i18n.t("conversation.reactions.react")}>
            {QUICK_REACTIONS.map((emoji) => (
              <button
                key={emoji}
                type="button"
                className={`${classes.reaction} ${myReaction && sameEmoji(myReaction, emoji) ? classes.reactionMine : ""}`}
                aria-label={emoji}
                onClick={() => {
                  handleClose();
                  onReact(emoji);
                }}
              >
                {emoji}
              </button>
            ))}
            {onReactMore && (
              <button
                type="button"
                className={`${classes.reaction} ${classes.reactionMore}`}
                aria-label={i18n.t("conversation.reactions.more")}
                title={i18n.t("conversation.reactions.more")}
                onClick={() => {
                  handleClose();
                  onReactMore();
                }}
              >
                <AddIcon />
              </button>
            )}
          </li>
        )}
        <MenuItem className={classes.item} onClick={hanldeReplyMessage}>
          <ReplyIcon />
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        <MenuItem className={classes.item} onClick={handleSetShowSelectCheckbox}>
          <ForwardIcon />
          {i18n.t("messageOptionsMenu.forward")}
        </MenuItem>
        {canEditMessage() && (
          <MenuItem key="edit" className={classes.item} onClick={handleEditMessage}>
            <EditOutlinedIcon />
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        {!message.fromMe && isGroup && (
          <MenuItem className={classes.item} onClick={() => handleSaveTicket(message?.contact?.id)}>
            <ChatOutlinedIcon />
            {i18n.t("messageOptionsMenu.talkTo")}
          </MenuItem>
        )}
        {message.fromMe && (
          <MenuItem
            key="delete"
            className={`${classes.item} ${classes.danger}`}
            onClick={handleOpenConfirmationModal}
          >
            <DeleteOutlineIcon />
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;